import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useRef } from "react";
import { IconButton } from "@mui/material";
import classNames from "classnames";
import HollowButton from "components/HollowButton";
import Button from "components/Button";
import Check from "@mui/icons-material/Check";
import Cancel from "@mui/icons-material/Cancel";
import { useTranslation } from "react-i18next";

const InputInline: FC<Props> = ({
  value,
  placeholder,
  onChange,
  onCancel,
  smallButtons = false,
  withoutBackground = false,
}) => {
  const { t } = useTranslation();
  const ref = useRef(null);

  return (
    <div
      className={classNames(
        styles.inlineEditor,
        withoutBackground ? styles.nobg : undefined
      )}
    >
      <input
        ref={ref}
        autoFocus={true}
        className={styles.newFolderInput}
        defaultValue={value}
        // onBlur={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        onKeyDownCapture={(e) => {
          if (e.key === "Enter") {
            const i = e.target as HTMLInputElement;
            onChange(i.value);
          } else if (e.key === "Escape") {
            onCancel();
          }
          e.stopPropagation();
        }}
        onClickCapture={(e) => e.stopPropagation()}
      ></input>

      {!smallButtons && (
        <>
          <HollowButton
            className={styles.smallButton}
            text={t("common.cancel")}
            onClick={() => {
              onCancel();
            }}
          ></HollowButton>
          <Button
            text={t("common.save")}
            onClick={() => onChange((ref.current as HTMLInputElement).value)}
            className={styles.smallButton}
          ></Button>
        </>
      )}
      {smallButtons && (
        <div className={styles.buttons}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              onChange((ref.current as HTMLInputElement).value);
            }}
          >
            <Check />
          </IconButton>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              onCancel();
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Cancel />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default InputInline;
